import React, { useEffect } from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IFlagNoteDialogProps {
    dialogName: string;
    handleConfirm?: (note: string, type: number) => void;
    hideDialog: () => void;
    label?: string;
    type?: number;
}

const FlagNoteDialog = (props: IFlagNoteDialogProps) => {
    useEffect(() => {
        onCreate();
    }, []);

    const onCreate = () => {
        console.log('DefineBudgetCategoryDialog onCreate()');
    };

    const OKClicked = () => {
        const reasonTextElement = document.getElementById('flagReasonDialogTextArea') as HTMLTextAreaElement;
        if (!!reasonTextElement) {
            props.handleConfirm(reasonTextElement?.value, props?.type);
        } else {
            props.handleConfirm('', props?.type);
        }
        props.hideDialog();
    };

    return (
        <Dialog
            title={props.type === 0 ?
                'Flag Billing Entry' : props.type === 2 ?
                    'Timesheet Reset Reason' : 'Apply Correction'}
            dialogName={props.dialogName}
            isExitButtonInvisible={true}
            bodyStyle={{ width: '15%' }}
        >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form
                    style={{width: '100%'}}
                >
                    <label>{!!props?.label ?
                        props?.label : (props?.type === 0 ?
                            `Please enter the reason to flag/stop this Billing Entry.` : props?.type === 2 ?
                                'Enter a reason for revoking timesheet approval' : `Correction Description`)}
                    </label>
                    <br />
                    <textarea
                        id={'flagReasonDialogTextArea'}
                        name={'flagReasonTextArea'}
                        style={{width: '100%', height: '10rem', resize: 'none'}}
                    />
                    <br />
                    <label>{`OK to ` + (props.type === 0 ? `flag.` : props?.type === 2 ? 'revoke.' : `correct.`) + ` Cancel to abort.`}</label>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'OK'}
                    onClick={() => OKClicked()}
                />
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem' }}
                    text={'Cancel'}
                    onClick={() => props.hideDialog()}
                />
            </div>
        </Dialog>
    );
};

export default FlagNoteDialog;



// WEBPACK FOOTER //
// ./src/components/project-billing/dialogs/FlagNoteDialog.tsx